import React from "react";
import { Apple, Smartphone } from "lucide-react";

const GUIDES = [
  ["play", Smartphone, "Google Play", "One-time $25 developer account", [
    "Create the app in Play Console (play.google.com/console).",
    "Fill the store listing — copy the text from the store listing file.",
    "Production → New release → upload the Google Play file (.aab). Choose \"Use Google-generated key\".",
    "After the first upload, copy the SHA-256 from App integrity → App signing and send it to your builder so the app opens without an address bar.",
    "When it's live, paste the Play link above.",
  ]],
  ["apple", Apple, "App Store", "$99/year developer account + a Mac with Xcode", [
    "Unzip the iPhone Xcode project on a Mac and open ios/App/App.xcodeproj.",
    "Signing & Capabilities → pick your Team (bundle id org.ishukart.app).",
    "Product → Archive → Distribute App → App Store Connect.",
    "Fill the listing in App Store Connect, add a demo login for Apple's reviewers and submit.",
    "When it's live, paste the App Store link above.",
  ]],
];

export const PublishSteps = () => (
  <div className="grid lg:grid-cols-2 gap-4" data-testid="mobile-publish-steps">
    {GUIDES.map(([key, Icon, title, need, steps]) => (
      <div key={key} className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6" data-testid={`mobile-guide-${key}`}>
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-xl bg-slate-900 text-white flex items-center justify-center"><Icon size={17} /></span>
          <div>
            <h3 className="font-display font-semibold text-slate-900">Publish on {title}</h3>
            <p className="text-xs text-slate-500">{need}</p>
          </div>
        </div>
        <ol className="mt-4 space-y-2.5">
          {steps.map((s, i) => (
            <li key={i} className="flex gap-3 text-sm text-slate-600"><span className="shrink-0 w-5 h-5 rounded-full bg-sky-50 ring-1 ring-sky-200 text-sky-700 text-[11px] font-semibold flex items-center justify-center">{i + 1}</span>{s}</li>
          ))}
        </ol>
      </div>
    ))}
  </div>
);

export default PublishSteps;
